import { render, staticRenderFns } from "./UndoRedoButton.vue?vue&type=template&id=633b4e52&scoped=true&"
import script from "./UndoRedoButton.vue?vue&type=script&lang=js&"
export * from "./UndoRedoButton.vue?vue&type=script&lang=js&"
import style0 from "./UndoRedoButton.vue?vue&type=style&index=0&id=633b4e52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633b4e52",
  null
  
)

export default component.exports